module.exports = __webpack_public_path__ + "static/media/27-skylde.7bc2dbb5.mp3";